// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React from 'react';
import {pick} from 'lodash';
import {renderCESIconByScoreType} from '../../utils';
import {CX_SCORE_TYPES} from '../../constants';

interface CESAnswerProps {
    message: any;
}

// Renders the CES Answer block with predefined payload values.
export const CESAnswer = (props: CESAnswerProps) => {
    const {message} = props;
    const {
        body,
        label_negative: labelNegative,
        label_positive: labelPositive,
    } = pick(message, ['body', 'label_negative', 'label_positive']);
    const {question, value} = body;
    // Get index of selected value
    const selectedIndex = value - 1;
    const renderedCxScoreTypes = () =>
        Object.keys(CX_SCORE_TYPES || {}).map((CX_SCORE_TYPE, i) => (
            <div key={i} className="message-cx__ces-icon-wrapper">
                {renderCESIconByScoreType(
                    CX_SCORE_TYPES[CX_SCORE_TYPE],
                    30,
                    'message-cx__ces-icon',
                    selectedIndex === i,
                )}
            </div>
        ));

    return (
        <div className="message-cx__ces-block">
            <div className="message-cx__ces-title-container">
                <span className="message-cx__ces-title">{question}</span>
            </div>
            <div className="message-cx__ces-icon-container">
                {renderedCxScoreTypes()}
            </div>
            <div className="message-cx__ces-label-container">
                <span className="message-cx__ces-label-negative">
                    {labelNegative}
                </span>
                <span className="message-cx__ces-label-positive">
                    {labelPositive}
                </span>
            </div>
        </div>
    );
};
